function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#212A33",
    fillRule: "evenodd",
    d: "M13.418 2.587l7.995 7.995a2.006 2.006 0 010 2.836l-7.995 7.995a2.006 2.006 0 01-2.836 0l-7.995-7.995a2.006 2.006 0 010-2.836l7.995-7.995a2.006 2.006 0 012.836 0zM13.5 8c-.276 0-.5.255-.5.532V10h-2c-1.657 0-3 1.338-3 3v2a.999.999 0 102 0v-1.478c0-.831.672-1.522 1.5-1.522H13v1.495a.499.499 0 00.848.36l3.581-2.481.012-.011a.503.503 0 00-.012-.71l-3.581-2.481C13.755 8.082 13.63 8 13.5 8z"
  }));
}

export var ReactComponent = SvgComponent;
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-directions.svg";